var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"template-checkout"}},[_c('transition',{attrs:{"name":"slide"}},[(_vm.isCheckout())?_c('BookingPage'):_vm._e(),_vm._v(" "),(_vm.isConfirmation())?_c('ConfirmationPage'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }